import _defineProperty from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useMemo as $58Phs$useMemo, useCallback as $58Phs$useCallback, useRef as $58Phs$useRef, useEffect as $58Phs$useEffect } from "react";
import { useMultipleSelectionState as $58Phs$useMultipleSelectionState, SelectionManager as $58Phs$SelectionManager } from "@react-stately/selection";
import { useCollection as $58Phs$useCollection } from "@react-stately/collections";
import { useControlledState as $58Phs$useControlledState } from "@react-stately/utils";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $a02d57049d202695$export$d085fb9e920b5ca7 = /*#__PURE__*/function (_Symbol$iterator) {
  function $a02d57049d202695$export$d085fb9e920b5ca7(nodes) {
    var _this = this;
    _classCallCheck(this, $a02d57049d202695$export$d085fb9e920b5ca7);
    this.keyMap = new Map();
    this.iterable = nodes;
    var visit = function visit(node) {
      _this.keyMap.set(node.key, node);
      if (node.childNodes && node.type === "section") {
        var _iterator = _createForOfIteratorHelper(node.childNodes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;
            visit(child);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    };
    var _iterator2 = _createForOfIteratorHelper(nodes),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var node = _step2.value;
        visit(node);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var last;
    var index = 0;
    var _iterator3 = _createForOfIteratorHelper(this.keyMap),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
          key = _step3$value[0],
          _node = _step3$value[1];
        if (last) {
          last.nextKey = key;
          _node.prevKey = last.key;
        } else {
          this.firstKey = key;
          _node.prevKey = undefined;
        }
        if (_node.type === "item") _node.index = index++;
        last = _node;
        // Set nextKey as undefined since this might be the last node
        // If it isn't the last node, last.nextKey will properly set at start of new loop
        last.nextKey = undefined;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    this.lastKey = last === null || last === void 0 ? void 0 : last.key;
  }
  _createClass($a02d57049d202695$export$d085fb9e920b5ca7, [{
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.delegateYield(this.iterable, "t0", 1);
          case 1:
          case "end":
            return _context.stop();
        }
      }, value, this);
    })
  }, {
    key: "size",
    get: function get() {
      return this.keyMap.size;
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return this.keyMap.keys();
    }
  }, {
    key: "getKeyBefore",
    value: function getKeyBefore(key) {
      var node = this.keyMap.get(key);
      return node ? node.prevKey : null;
    }
  }, {
    key: "getKeyAfter",
    value: function getKeyAfter(key) {
      var node = this.keyMap.get(key);
      return node ? node.nextKey : null;
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      return this.firstKey;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      return this.lastKey;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.keyMap.get(key);
    }
  }, {
    key: "at",
    value: function at(idx) {
      var keys = _toConsumableArray(this.getKeys());
      return this.getItem(keys[idx]);
    }
  }, {
    key: "getChildren",
    value: function getChildren(key) {
      var node = this.keyMap.get(key);
      return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
  }]);
  return $a02d57049d202695$export$d085fb9e920b5ca7;
}(Symbol.iterator);
function $e72dd72e1c76a225$export$2f645645f7bca764(props) {
  var filter = props.filter;
  var selectionState = (0, $58Phs$useMultipleSelectionState)(props);
  var disabledKeys = (0, $58Phs$useMemo)(function () {
    return props.disabledKeys ? new Set(props.disabledKeys) : new Set();
  }, [props.disabledKeys]);
  var factory = (0, $58Phs$useCallback)(function (nodes) {
    return filter ? new (0, $a02d57049d202695$export$d085fb9e920b5ca7)(filter(nodes)) : new (0, $a02d57049d202695$export$d085fb9e920b5ca7)(nodes);
  }, [filter]);
  var context = (0, $58Phs$useMemo)(function () {
    return {
      suppressTextValueWarning: props.suppressTextValueWarning
    };
  }, [props.suppressTextValueWarning]);
  var collection = (0, $58Phs$useCollection)(props, factory, context);
  var selectionManager = (0, $58Phs$useMemo)(function () {
    return new (0, $58Phs$SelectionManager)(collection, selectionState);
  }, [collection, selectionState]);
  // Reset focused key if that item is deleted from the collection.
  var cachedCollection = (0, $58Phs$useRef)(null);
  (0, $58Phs$useEffect)(function () {
    if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
      var startItem = cachedCollection.current.getItem(selectionState.focusedKey);
      var cachedItemNodes = _toConsumableArray(cachedCollection.current.getKeys()).map(function (key) {
        var itemNode = cachedCollection.current.getItem(key);
        return itemNode.type === "item" ? itemNode : null;
      }).filter(function (node) {
        return node !== null;
      });
      var itemNodes = _toConsumableArray(collection.getKeys()).map(function (key) {
        var itemNode = collection.getItem(key);
        return itemNode.type === "item" ? itemNode : null;
      }).filter(function (node) {
        return node !== null;
      });
      var diff = cachedItemNodes.length - itemNodes.length;
      var index = Math.min(diff > 1 ? Math.max(startItem.index - diff + 1, 0) : startItem.index, itemNodes.length - 1);
      var newNode;
      while (index >= 0) {
        if (!selectionManager.isDisabled(itemNodes[index].key)) {
          newNode = itemNodes[index];
          break;
        }
        // Find next, not disabled item.
        if (index < itemNodes.length - 1) index++;else {
          if (index > startItem.index) index = startItem.index;
          index--;
        }
      }
      selectionState.setFocusedKey(newNode ? newNode.key : null);
    }
    cachedCollection.current = collection;
  }, [collection, selectionManager, selectionState, selectionState.focusedKey]);
  return {
    collection: collection,
    disabledKeys: disabledKeys,
    selectionManager: selectionManager
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $a0d645289fe9b86b$export$e7f05e985daf4b5f(props) {
  var _props_defaultSelectedKey;
  var _ref = (0, $58Phs$useControlledState)(props.selectedKey, (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : null, props.onSelectionChange),
    _ref2 = _slicedToArray(_ref, 2),
    selectedKey = _ref2[0],
    setSelectedKey = _ref2[1];
  var selectedKeys = (0, $58Phs$useMemo)(function () {
    return selectedKey != null ? [selectedKey] : [];
  }, [selectedKey]);
  var _ref3 = (0, $e72dd72e1c76a225$export$2f645645f7bca764)(_objectSpread(_objectSpread({}, props), {}, {
      selectionMode: "single",
      disallowEmptySelection: true,
      allowDuplicateSelectionEvents: true,
      selectedKeys: selectedKeys,
      onSelectionChange: function onSelectionChange(keys) {
        var key = keys.values().next().value;
        // Always fire onSelectionChange, even if the key is the same
        // as the current key (useControlledState does not).
        if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
        setSelectedKey(key);
      }
    })),
    collection = _ref3.collection,
    disabledKeys = _ref3.disabledKeys,
    selectionManager = _ref3.selectionManager;
  var selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
  return {
    collection: collection,
    disabledKeys: disabledKeys,
    selectionManager: selectionManager,
    selectedKey: selectedKey,
    setSelectedKey: setSelectedKey,
    selectedItem: selectedItem
  };
}
export { $e72dd72e1c76a225$export$2f645645f7bca764 as useListState, $a0d645289fe9b86b$export$e7f05e985daf4b5f as useSingleSelectListState, $a02d57049d202695$export$d085fb9e920b5ca7 as ListCollection };